import {Component, OnInit} from '@angular/core';
import {UserDataService} from '../../user-data.service';
import {NgForm} from '@angular/forms';
import {Router} from '@angular/router';
import {SelectLocationTable} from '../../../../../shared/location-select.table';
import { el } from 'date-fns/locale';

@Component({
    selector: 'app-edit-user-account',
    templateUrl: './edit-user-account.component.html',
    styleUrls: ['./edit-user-account.component.scss'],
    providers: [SelectLocationTable]
})
export class EditUserAccountComponent implements OnInit {
    constructor(private userDataService: UserDataService,
                private router: Router,
                private locationSelect: SelectLocationTable) {}

    formResponse: boolean;
    formSent: boolean;

    // --- Dropdown for country and city
    selectedCountry: String = '--Choose Country--';
    selectedCity: String = '--Choose City--';

    Countries = this.locationSelect.Countries;
    customSuccessMessage: string;

    cities: Array<any> = []; //Angular 11

    changeCountry(country: any) { //Angular 11
        this.cities = this.Countries.find((cntry: any) => cntry.name == country.target.value).cities; //Angular 11
    }

    // --- End of dropdown for country and city

    userData: any = [];
    newUserInfo: object;

    firstNameFail: boolean;
    lastNameFail: boolean;

    ngOnInit() {
        this.userDataService.getData()
            .subscribe(user => {
                this.userData = user;
                console.log(this.userData, "?? user ??")
                if (this.userData.userCountry != null) {
                    this.selectedCountry = this.userData.userCountry;
                }

                if (this.userData.city != null) {
                    this.selectedCity = this.userData.city;
                }

                if (this.selectedCountry != null) {
                    this.cities = this.Countries.find((cntry: any) => cntry.name == this.selectedCountry).cities;
                }

            }, error => {
            });
    }

    letterCheck(name, value){
        if(name === 'lastName') {
            if(!(/^[a-zăîșțâA-ZĂÎȘȚÂ\s\-\']*$/.test(value))){
                console.log(value)
                this.lastNameFail = true;
            }else{
                console.log(value)
                this.lastNameFail = false;
            }
        }
        if(name === 'firstName') {
            if(!(/^[a-zăîșțâA-ZĂÎȘȚÂ\s\-\']*$/.test(value))){
                this.firstNameFail = true;
            }else{
                this.firstNameFail = false;
            }
        }
    }

    onSubmit(form: NgForm) {

        // if(!(/^[a-zăîșțâA-ZĂÎȘȚÂ\s\-\']*$/.test(form.value.firstName))){
        //     this.firstNameFail = true;
        //     return;
        // }

        // if(!(/^[a-zăîșțâA-ZĂÎȘȚÂ\s\-\']*$/.test(form.value.lastName))){
        //     this.lastNameFail = true;
        //     return;
        // }
        if(this.firstNameFail || this.lastNameFail){
            return;
        }

        this.newUserInfo = {
            firstName: form.value.firstName,
            lastName: form.value.lastName,
            city: form.value.userCity,
            country: form.value.userCountry,
            address: form.value.address
        }

        this.userDataService.updateAccountDetails(this.newUserInfo).subscribe(resData => {
            console.log('resData', resData)
            console.log(this.newUserInfo)
            this.formResponse = true;
            this.customSuccessMessage = "Modificările au fost efectuate cu succes"
            this.formSent = true;

            setTimeout(() => {
                this.router.navigate(['/cont']);
            }, 4000);

        }, error => {
            this.formResponse = false;
            this.formSent = true;
        });
    }
}
